import Axios from '@/components/api/axios.js'

export default {
    // 获取实时值
    getRtValueList: (pageIndex, pageSize, name, success, failure) => {
        Axios.post('/manualInputVariable/getRtValueList', {
            pageIndex,
            pageSize,
            name
        }, success, failure)
    },

    // 导出实时值
    rtValueExport: (listString, success, failure) => {
        Axios.post('manualInputVariable/rtValueExport', { listString }, success, failure)
    },

    // 更新实时值
    rtValueUpdate: (listString, success, failure) => {
        Axios.post('manualInputVariable/rtValueUpdate', { listString }, success, failure)
    },

    // 获取历史日数据
    getHistoryexList: (date, timeInterval, pageIndex, pageSize, name, success, failure) => {
        Axios.post('/manualInputVariable/getHistoryexList', {
            date,
            timeInterval,
            pageIndex,
            pageSize,
            name
        }, success, failure)
    },

    // 获取历史月数据
    getHistorydayList: (date, pageIndex, pageSize, name, success, failure) => {
        Axios.post('/manualInputVariable/getHistorydayList', {
            date,
            pageIndex,
            pageSize,
            name
        }, success, failure)
    },

    // 导出历史数据
    exportHistoryExcel: (historyValueVO, success, failure) => {
        Axios.post('manualInputVariable/exportHistoryExcel', historyValueVO, success, failure)
    },

    // 更新到历史库
    saveHistory: (historyValueVO, success, failure) => {
        Axios.post('manualInputVariable/saveHistory', historyValueVO, success, failure)
    },

    // 差值转换成累加值
    toAccumulateValue: (historyValueVO, success, failure) => {
        Axios.post('manualInputVariable/toAccumulateValue', historyValueVO, success, failure)
    },

    // 根据首尾自动平均
    getAvgByStartAndNext: (historyValueVO, success, failure) => {
        Axios.post('manualInputVariable/getAvgByStartAndNext', historyValueVO, success, failure)
    },

    // 根据两值自动增量
    getStartTwoValueToAdd: (historyValueVO, success, failure) => {
        Axios.post('manualInputVariable/getStartTwoValueToAdd', historyValueVO, success, failure)
    },
}